import React from 'react';

interface IProps {
  fillColor?: string;
}

const MoveBackIcon:React.FC<IProps> = (props) => {
  return (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.3463 0H8.25579C7.86842 0 7.50526 0.311458 7.50526 0.694792V3.83333H4.47895C4.11579 3.83333 3.63158 4.19271 3.63158 4.57604V7.90625H0.726316C0.338947 7.90625 0 8.09792 0 8.48125V22.3531C0 22.7365 0.338947 23 0.726316 23H14.8168C15.2042 23 15.2526 22.7365 15.2526 22.3531V19.1667H18.5695C18.9568 19.1667 19.1263 18.8312 19.1263 18.4479V15.0938H22.3463C22.7337 15.0938 23 14.95 23 14.5667V0.694792C23 0.311458 22.7095 0 22.3463 0ZM13.8 21.3229H1.21053V9.34375H13.8V21.3229ZM17.6737 17.4896H15.2526V8.48125C15.2526 8.09792 15.2042 7.90625 14.8168 7.90625H5.32632V5.51042H17.6737V17.4896Z" fill={props.fillColor ?? "#59626C"}/>
    </svg>
  )
}

export default MoveBackIcon;
